import React from "react";
import PropTypes from "prop-types";

const MissingTable = ({ data }) => {
  if (!data || data.length === 0) {
    return <p>No attendance data available</p>;
  }

  const headers = Object.keys(data[0]);

  return (
    <div
      style={{
        overflowX: "auto",
        border: "1px solid #ddd",
        borderRadius: 6,
        padding: 10,
        backgroundColor: "#fff"
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: 14,
          textAlign: "left"
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f4f6f8" }}>
            {headers.map((header) => (
              <th
                key={header}
                style={{
                  borderBottom: "1px solid #ddd",
                  padding: "8px 10px",
                  fontWeight: 600,
                  textTransform: "capitalize"
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              style={{
                backgroundColor:
                  rowIndex % 2 === 0 ? "#fff" : "#fafafa"
              }}
            >
              {headers.map((header) => (
                <td
                  key={header}
                  style={{
                    borderBottom: "1px solid #eee",
                    padding: "8px 10px"
                  }}
                >
                  {row[header] || "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

MissingTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default MissingTable;
